import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

const STORAGE_KEY = 'layanansynexa_theme';

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'cyan';
    } catch {
      return 'cyan';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // localStorage not available
    }

    // Apply/remove theme class on root element
    if (theme === 'classic') {
      document.documentElement.classList.add('theme-classic');
    } else {
      document.documentElement.classList.remove('theme-classic');
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === 'cyan' ? 'classic' : 'cyan'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
